<template>
	<div>
		<div class="head">
	<!-- 		<img src="@/assets/headImg/headimg.jpg" style="width: 100%;
		vertical-align:top;" /> -->
			<!-- 		<div class="retrun" @click="retrun">
				返回首页
			</div> -->

			<div style="margin-top: 10px;">
				<!-- <video controls src="../../assets/video/1.mp4" style="width: 100%;"></video> -->
			</div>
			
			
			<el-row style="width: 100%;display: flex;align-items: center;">
				<el-col :span="6">
					<div>
						<div>3675人正在看，2995条弹幕</div>
					</div>
				</el-col>
				<el-col :span="2">
					<div>
						<el-switch v-model="value" active-color="#13ce66" inactive-color="#ff4949">
						</el-switch>
					</div>
				</el-col>
				<el-col :span="16">
					<div style="display: flex;">
						<input class="input"  placeholder="发个友善的弹幕见证当下" style="padding-left: 20px;" />
						  <div class="fasong">发送</div>
					</div>
				</el-col>
			</el-row>

		</div>


	</div>
</template>

<script>
	export default{
		data(){
			return{
				value:true
			}
		}
	}
</script>

<style scoped>
	.head {
		width: 980px;
		margin: 0 auto;
		padding-right: 16px;
	}
	.input{
		width: 50%;
		height: 30px;
		border: 1px solid #afafaf;
		background-color: #f4f4f4;
		border-radius: 3px 0 0 3px;
	}
	.fasong{
		width: 70px;
		height: 34px;
		line-height: 34px;
		background-color: #1aabf9;
		color: #fff;
		text-align: center;
		border-radius: 0 3px 3px 0;
		font-size: 14px;
	}
</style>
